import { useState, useEffect } from 'react';
import { fetchCertificate, generateCertificate as generateCertificateService } from '../../../services/documentService';
import { useDispatch } from 'react-redux';
import { AppDispatch } from 'redux/store';
import { fetchCertificateEnabled } from '../../../redux/slicers/instanceSlice';

const useCertificate = () => {
  const [certificate, setCertificate] = useState<null | { fileUrl: string }>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  const dispatch = useDispatch<AppDispatch>();

  useEffect(() => {
    const fetchData = async () => {
  try {
    const response = await fetchCertificate();
    if (response.code === 'CERTIFICATE_FETCHED_SUCCESSFULLY') {
      setCertificate({ fileUrl: response.data[0].fileUrl });
    } else if (response.code === 'CERTIFICATE_NOT_FOUND') {
      setCertificate(null);
    } else {
      setCertificate(null);
      setError('Unexpected server response');
    }
  } catch (err) {
    setError('Failed to fetch certificate');
  } finally {
    setLoading(false);
  }
};
    fetchData();
    dispatch(fetchCertificateEnabled());
  }, []);

  const generateCertificate = async () => {
    setLoading(true);
    try {
      const response = await generateCertificateService();
      if (response.code === 'CERTIFICATE_READY') {
        setCertificate({ fileUrl: response.url });
      } else {
        setCertificate(null);
      }
    } catch (err) {
      setError('Failed to generate certificate');
    } finally {
      setLoading(false);
    }
  };

  return { certificate, loading, generateCertificate, error };
};

export default useCertificate;
